import request from '@/utils/request'


//入库扫码列表
export function receiptScanList(query) {
    return request({
        url: '/api/produce/receipt/scan/pagelist',
        method: 'get',
        params: query
    })
}
//入库单列表
export function receiptList(query) {
    return request({
        url: '/api/produce/receipt',
        method: 'get',
        params: query
    })
}
// 新建入库单
export function receiptAdd(data) {
    return request({
        url: '/api/produce/receipt/create',
        method: 'post',
        data
    })
}
//入库单详情
export function receiptDetail(id) {
    return request({
        url: `/api/produce/receipt/${id}`,
        method: 'get',
    })
}

// 修改入库单
export function receiptUpdate(data) {
    return request({
        url: '/api/produce/receipt/update',
        method: 'post',
        data
    })
}
// 确认入库单
export function receiptConfirm(data) {
    return request({
        url: '/api/produce/receipt/confirm',
        method: 'post',
        data
    })
}


//删除入库单
export function receiptDelete(query) {
    return request({
        url: `/api/produce/receipt/delete`,
        method: 'get',
        params: query
    })
}
//删除明细列表
export function receiptTableDelete(query) {
    return request({
        url: `/api/produce/transfer-out/delete-detail`,
        method: 'get',
        params: query
    })
}


// 新增调拨出库单
export function transferAdd(data) {
    return request({
        url: '/api/produce/transfer-out/add',
        method: 'post',
        data
    })
}
// 修改调拨出库单
export function transferUpdate(data) {
    return request({
        url: '/api/produce/transfer-out/update',
        method: 'post',
        data
    })
}
// 取消调拨出库单
export function transferCancel(query) {
    return request({
        url: '/api/produce/transfer-out/cancel',
        method: 'get',
        params: query
    })
}
// 确认调拨出库单
export function transferConfirm(query) {
    return request({
        url: '/api/produce/transfer-out/confirm',
        method: 'get',
        params: query
    })
}

// 完成调拨出库单
export function transferComplete(query) {
    return request({
        url: '/api/produce/transfer-out/complete',
        method: 'get',
        params: query
    })
}
// 确认调拨出库明细实际调拨数量
export function transferConfirmDetail(query) {
    return request({
        url: '/api/produce/transfer-out/confirm-detail-quantity',
        method: 'get',
        params: query
    })
}
//批量
export function transferConfirmAllDetail(data) {
    return request({
        url: '/api/produce/transfer-out/batch-confirm-detail-quantity',
        method: 'post',
        data
    })
}
// 删除
export function transferDelete(query) {
    return request({
        url: '/api/produce/transfer-out/delete',
        method: 'get',
        params: query
    })
}

//调拨出库单详情
export function transferDetail(query) {
    return request({
        url: `/api/produce/transfer-out/detail`,
        method: 'get',
        params: query
    })
}

//分页查询调拨出库单列表
export function transferList(query) {
    return request({
        url: '/api/produce/transfer-out/list',
        method: 'get',
        params: query
    })
}

//获取调拨出库扫码记录列表
export function transferScanList(query) {
    return request({
        url: '/api/produce/transfer-out-scan/pagelist',
        method: 'get',
        params: query
    })
}
